import * as React from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./routes.css";
import annMovement from "../img/annMovement.jpg";
import ReactiveTriadsLogo from "../img/greenReactiveTriadsBodyworkLogo.png";

const rtLogo = {
  maxWidth: "220px",
  width: "100%",
  height: "auto",
  marginBottom: "1rem",
};
const videoWrap = {
  maxWidth: "45rem",
  margin: "1rem auto 0",
  borderRadius: "0.5rem",
  overflow: "hidden",
  boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 5px 2px",
};

function Classes() {
  return (
    <div className="pageBg">
      <div className="container">
        <div className="pageCard">
          <h2 className="pageTitle">Classes &amp; Training</h2>

          <p className="pageLead">
            Conscious Anatomy™ Movement: learn anatomy through blissful yogic
            movement flows that integrate body, mind, and spirit. Available
            anytime online at your own pace, and live or in person a few times
            a year.
          </p>

          {/* Conscious Anatomy Movement */}
          <h3 className="sectionTitle">Conscious Anatomy™ Movement</h3>
          <div className="profile">
            <img
              src={annMovement}
              className="profilePhoto"
              alt="Ann Watkins teaching a movement class"
            />
            <div className="profileBody">
              <p>
                Conscious Anatomy™ Movement is for everyone who wants to learn
                anatomy through blissful yogic movement flows that focus on the
                integration of body, mind, and spirit. It is especially for
                manual and movement therapists who really want to understand
                how living, moving bodies work from the inside out. And, as one
                student put it, &ldquo;learn the anatomical terms and concepts
                without really trying&rdquo;.
              </p>
              <p>
                Ann Watkins, Masters in Dance Movement Therapy, certified in
                Expressive Arts Therapy, nationally licensed in massage and
                bodywork, owner of New Harmony Therapeutic Massage and Somatic
                Bodywork since 1988, is passionate about movement, increasing
                knowledge, healing herself and offering healing to others,
                believing those things bring more harmony to the whole world.
                She is a Peace Spider spinning her fabric of contemplation for
                all to participate in. Please join her if you can.
              </p>
              <p>
                <strong>
                  Changing the awareness of the world one class, one training
                  at a time.
                </strong>{" "}
                In Conscious Anatomy™ we feel better after class than when we
                started. We become healthier and more vital while we learn the
                language of anatomy and absorb anatomical terms and concepts
                through movement. Simultaneously, as we move, we relieve muscle
                tension with somatic awareness; with energetic attunement, we
                learn how to make our energy body more tangible so it works for
                us in our daily lives and careers; and, we open our brains to
                become sponges for learning anatomy. Experience heightened
                energetic awareness, decreased tension, track down inner peace,
                become healthier and more graceful in body mind and spirit and
                discover ease in learning anatomy and function while healing
                your body at the same time. Infuse greater vitality into your
                life. You might even discover yourself embarking on a new
                career path.
              </p>
            </div>
          </div>

          <div style={videoWrap}>
            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/NYKKulvYOeU"
                title="Become a Sponge for Anatomical Terms and Concepts with Conscious Anatomy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <p className="photoCaption" style={{ textAlign: "center" }}>
            <span>
              Become a Sponge for Anatomical Terms and Concepts Through Self
              Care with Conscious Anatomy™
            </span>
          </p>

          {/* Course series */}
          <h3 className="sectionTitle">Course Series</h3>
          <p>
            Conscious Anatomy™ Movement is a four level course series. It
            starts with Bones, Planes and Directions in Level I and moves into
            Muscles and Attachments in the following levels. Conscious Anatomy™
            then builds into Reactive Triads™ Bodywork training. For dates and
            times please see{" "}
            <a
              href="https://www.bodymindspiritanatomy.com/"
              target="_blank"
              rel="noreferrer"
            >
              bodymindspiritanatomy.com
            </a>
            .
          </p>

          <div className="row g-4">
            <div className="col-md-6">
              <h4 className="subTitle">Conscious Anatomy™</h4>
              <ul className="courseList">
                <li>
                  <strong>Level I: Bones, Planes and Directions</strong>
                  <span>One eight-week module.</span>
                </li>
                <li>
                  <strong>Level II: Muscles and Attachments</strong>
                  <span>
                    Three eight-week modules where you will discover how
                    muscles fire sequentially with one another as we move, and
                    bliss out in the movement at the same time.
                  </span>
                </li>
                <li>
                  <strong>Level III: Somatic Awareness</strong>
                  <span>
                    Deepen somatic awareness and energetic attunement and have
                    anatomy at your fingertips.
                  </span>
                </li>
              </ul>
            </div>
            <div className="col-md-6">
              <h4 className="subTitle">Reactive Triads™ Bodywork</h4>
              <ul className="courseList">
                <li>
                  <strong>Level I: Muscle, Triads &amp; Jolts</strong>
                </li>
                <li>
                  <strong>Level II: Muscle, Lymph, Triads &amp; Mixed Triads</strong>
                </li>
              </ul>
              <p>
                Classes in Anatomy and Muscle Testing are prerequisites for
                Reactive Triads™ classes.
              </p>
            </div>
          </div>

          {/* Reactive Triads training */}
          <h3 className="sectionTitle">Reactive Triads™ Bodywork Training</h3>
          <img
            src={ReactiveTriadsLogo}
            style={rtLogo}
            alt="Reactive Triads Bodywork logo"
          />
          <p>
            Interested in bodywork, or perhaps you are already a massage or
            manual therapist? Conscious Anatomy™ builds into Reactive Triads™
            Bodywork: a chronic pain breakthrough, engaging three body systems
            in a form of bodywork that is tremendously effective for reducing
            or eliminating chronic and acute muscle pain, and is postural
            corrective. It teaches muscles how to relax.
          </p>
          <p>
            Ann&rsquo;s DVD, <em>Reactive Triads™: A Breakthrough in Chronic
            Pain Relief</em> (2006), documents her original bodywork involving
            the muscle system, the lymphatic system and the joint system, and
            is a great supplement to her courses.
          </p>
          <Link to="/store">
            <Button>Reactive Triads™ DVD ››</Button>
          </Link>

          {/* Supervision */}
          <h3 className="sectionTitle">Supervision &amp; Mentoring</h3>
          <p>
            I am available to help you build greater confidence and a more
            effective practice through supervision and mentoring. This can
            happen in person, over the phone or over video conferencing (Zoom).
            Prepare your questions before each call and I will provide you with
            helpful guidance. I&rsquo;ve had a thriving practice since 1988 and
            can answer questions on how to build a practice from the ground up
            with guidance on how to more effectively treat your clients. This
            is especially useful if you have taken courses with me and are
            applying the work in sessions with your clients.
          </p>
          <div className="missionQuote">
            <strong>Phone mentoring:</strong> $40.00 per half hour. Free
            consultation to see if this is right for you.
          </div>

          {/* Contact */}
          <div className="contactBox">
            <h4 className="subTitle" style={{ marginTop: 0 }}>
              Questions? Contact Ann
            </h4>
            <p>
              Phone <a href="tel:8605994533">(860) 599-4533</a>
              <br />
              Email{" "}
              <a href="mailto:bodymindspiritanatomy@gmail.com">
                bodymindspiritanatomy@gmail.com
              </a>
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
              <a
                href="https://www.bodymindspiritanatomy.com/"
                target="_blank"
                rel="noreferrer"
              >
                <Button>Purchase Courses ››</Button>
              </a>
              <Link to="/testimonials">
                <Button variant="outline-primary">Testimonials ››</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Classes;
